import React from 'react';

export function NotFoundPage(): React.ReactElement {
	return <h1>404 - Page not found</h1>;
}
